import { render, staticRenderFns } from "./modal-bieuphi-tragop.vue?vue&type=template&id=d6b01036&scoped=true"
import script from "./modal-bieuphi-tragop.vue?vue&type=script&lang=js"
export * from "./modal-bieuphi-tragop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b01036",
  null
  
)

export default component.exports